import {Component, Input, OnInit} from '@angular/core';
import { SharedDataService } from '../../services/shared-data.service';

@Component({
  selector: 'app-sort-button',
  templateUrl: './sort-button.component.html',
  styleUrls: ['./sort-button.component.scss']
})
export class SortButtonComponent implements OnInit {

  @Input() state: string;
  // private sortOrder:string;
  public sortDirections;
  constructor(public sharedDataService: SharedDataService) { }

  ngOnInit() {
    this.sortDirections = SharedDataService.SORT_DIRECTIONS;
  }

  public changeSortOrder (direction: string): void {
    this.sharedDataService.sortOrder = direction;
  }

}
